import React from 'react';
import { Order, SeedTicket } from 'constants/interface';
import { Popover } from 'UI';
import { useBreadcrumbNavigation } from 'hooks/breadcrumb';
import { useRouteMatch } from 'react-router';
import { ROUTES } from 'constants/routes';

import {
  PopoverContentWrapper,
  ActionButton,
} from './style';

interface TableRowActionProps {
  // ticket: SeedTicket
  index: number
  isActive: boolean
  onVisibleChange: (visibleIndex?: number) => void
  onDetails: (index: number) => void
}

const TableRowAction = ({
  // ticket,
  index,
  isActive,
  onVisibleChange,
  onDetails,
}: TableRowActionProps): JSX.Element => {
  const internalVisibleChange = (
    isVisible: boolean,
  ): void => {
    onVisibleChange(isVisible ? index : undefined);
  };

  const onDetailsClick = () => {
    onDetails(index);
  };

  // const onCopyClick = () => {
  //   onOrderCopy(order.id);
  //   breadcrumbNavigator.push({
  //     label: 'Novo pedido',
  //     url: `${url}${ROUTES.orders.new.root}`,
  //   });
  // };

  return (
    <Popover
      placement="bottom"
      trigger="click"
      visible={isActive}
      onVisibleChange={internalVisibleChange}
      content={(
        <PopoverContentWrapper>
          <ActionButton
            onClick={() => {
              // internalVisibleChange(false);
              onDetailsClick();
            }}
          >
            Detalhes
          </ActionButton>
          <ActionButton
            onClick={() => {
              internalVisibleChange(false);
              // onCopyClick();
            }}
          >
            Cancelar
          </ActionButton>
        </PopoverContentWrapper>
      )}
    >
      <ActionButton>
        Ação
      </ActionButton>
    </Popover>
  );
};

export default TableRowAction;
